import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tool-header-search__submit" }

import { mapModifires, type typeModifires } from "@/components/utils/modifires";
import { InputField, ButtonSubmit } from "@/components/modules";
import { withDefaults, defineOptions } from "vue";

interface Props {
  modifires?: typeModifires;
  inputType?:
    | "text"
    | "number"
    | "tel"
    | "email"
    | "url"
    | "password"
    | "search";
  buttonType?: "button" | "submit";
  placeholder?: string;
}


export default /*#__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false,
},
  __name: 'tool-header-search',
  props: {
    modifires: { type: [String, Array, Boolean] },
    inputType: {},
    buttonType: {},
    placeholder: {}
  },
  emits: ["update", "click"],
  setup(__props: any, { emit }) {

const props = __props;






const handleInput = (e: Event) => {
  emit("update", (e.target as HTMLInputElement).value);
};

const handleClick = (e: Event) => {
  emit("click", e);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(mapModifires)('tool-header-search', _ctx.modifires))
  }, [
    _createVNode(_unref(InputField), _mergeProps(_ctx.$attrs, {
      onInput: handleInput,
      type: _ctx.inputType,
      placeholder: _ctx.placeholder,
      maxlength: 255
    }), null, 16, ["type", "placeholder"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(ButtonSubmit), {
        class: "tool-header-search__submit",
        type: _ctx.buttonType,
        onClick: handleClick
      }, null, 8, ["type"])
    ])
  ], 2))
}
}

})